module.exports = __webpack_public_path__ + "img/company3.58138d18.png";